// generated by genversion
export var version = '4.7.13';
//# sourceMappingURL=version.js.map